import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/services/api-client";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useToast } from "@/hooks/use-toast";

interface UserMeResponse {
  id: number | string;
  notion_url?: string | null;
  dropbox?: boolean | null;
}

const ConfigPage = () => {
  const [user, setUser] = useState<UserMeResponse | null>(null);
  const { toast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await apiClient.get<UserMeResponse>("/me");
        setUser(data);
      } catch (error) {
        console.error("Failed to fetch user info", error);
        toast({
          title: "Error",
          description: "Failed to load user information.",
        });
      }
    };
    fetchUser();
  }, []);

  const initiateOAuth = async (endpoint: string) => {
    try {
      const { auth_url } = await apiClient.get<{ auth_url: string }>(endpoint);
      window.location.href = auth_url;
    } catch (error) {
      console.error("Failed to get OAuth URL", error);
      toast({
        title: "Error",
        description: "Failed to initiate OAuth flow.",
      });
    }
  };

  if (!user) {
    return (
      <div className="container mx-auto py-10 px-4">
        <Skeleton className="w-full h-40" />
      </div>
    );
  }

  return (
    <div className="container mx-auto py-10 px-4 max-w-lg">
      <h1 className="text-3xl font-bold mb-6 text-center">Configuration</h1>
      <div className="space-y-6">
        {/* Dropbox */}
        <div className="flex items-center justify-between">
          <span className="text-lg font-medium">Dropbox</span>
          {user.dropbox ? (
            <span className="text-green-600 font-semibold">Connected</span>
          ) : (
            <Button onClick={() => initiateOAuth("/dbox/oauth_login")}>Connect Dropbox</Button>
          )}
        </div>

        {/* Notion */}
        <div className="flex items-center justify-between">
          <span className="text-lg font-medium">Notion</span>
          {user.notion_url ? (
            <a
              href={user.notion_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Open Notion
            </a>
          ) : (
            <Button onClick={() => initiateOAuth("/notion/oauth_login")}>Connect Notion</Button>
          )}
        </div>

        <div className="pt-8 text-center">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfigPage;
